import React from "react";
import { FinancialDocumentExtended } from "@common/types/financialDocument";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { FinancialDocumentDetailsView } from "../usePathBasedFinancialDocumentDetailsView";
import { useFinancialDocumentDetailsContext } from "../financialDocumentDetails.context";
import styles from "./FinancialDocumentMatches.module.scss";
import { FinancialDocumentMatchesList } from "./FinancialDocumentMatchesList";
import { FinancialDocumentJournalEntries } from "./FinancialDocumentJournalEntries";
import { FinancialDocumentAccrualLinks } from "./FinancialDocumentAccrualLinks";
import { FinancialDocumentCounterpartyLink } from "./FinancialDocumentCounterpartyLink";

interface FinancialDocumentMatchesProps {
    financialDocument: FinancialDocumentExtended;
}

export const FinancialDocumentMatches: React.FC<
    FinancialDocumentMatchesProps
> = ({ financialDocument }) => {
    const { changeView } = useFinancialDocumentDetailsContext();
    const hasMatches = financialDocument.transactionMatches.length > 0;

    return (
        <section className={styles.container}>
            {hasMatches && (
                <FinancialDocumentMatchesList
                    financialDocument={financialDocument}
                />
            )}
            <FinancialDocumentJournalEntries
                financialDocument={financialDocument}
            />
            <FinancialDocumentAccrualLinks
                financialDocument={financialDocument}
            />
            <FinancialDocumentCounterpartyLink
                financialDocument={financialDocument}
            />
            {hasMatches && (
                <footer
                    className={classNames(
                        styles.section,
                        styles.matchingFooter,
                    )}
                >
                    <Button
                        variant="primary"
                        size="md"
                        onClick={() =>
                            changeView(FinancialDocumentDetailsView.MATCHING)
                        }
                        data-testid="financial-document-matches-add-transaction"
                    >
                        Match with another transaction
                    </Button>
                </footer>
            )}
        </section>
    );
};
